module.exports = __webpack_public_path__ + "static/is-11-094196c37f5053afe5affbe45c45e6ca.png";